import {
  TrelloModel,
  TrelloModelAttributes,
} from 'app/scripts/models/internal/trello-model';

interface CustomEmojiAttributes extends TrelloModelAttributes {
  name: string;
  url: string;
}

class CustomEmoji extends TrelloModel<CustomEmojiAttributes> {
  static initClass() {
    this.prototype.typeName = 'CustomEmoji';
  }
}
CustomEmoji.initClass();

export { CustomEmoji };
